module.exports = __webpack_public_path__ + "img/carousel6.7dfaa3b6.jpg";